
const MenuEnlacesDX = ({ iddx, idrecepcion, buttonActive, estadoDx }) => {

    const estadoDxNum = Number(estadoDx);
    return (
        <div className="btn-group">
            <a href={`/dx/identificacion/${iddx}/${idrecepcion}`} 
                id="aIdentificacion"  
                className={(buttonActive === 1)?'btn btn-primary':'btn btn-default'} 
                >Identificaci&oacute;n
            </a>
            {estadoDxNum >= 2 && (
                <a href={`/dx/hogar/${iddx}/${idrecepcion}`} 
                    id="aHogar"  
                    className={(buttonActive === 2)?'btn btn-primary':'btn btn-default'} 
                    >Hogar
                </a>
            )}
            {estadoDxNum >= 3 && (
                <a href={`/dx/diferenciales/${iddx}/${idrecepcion}`} 
                    id="aDiferenciales"  
                    className={(buttonActive === 3)?'btn btn-primary':'btn btn-default'} 
                    >Diferenciales
                </a>
            )}
            {estadoDxNum >= 4 && (
            <a href={`/dx/ubicacion/${iddx}/${idrecepcion}`} 
                id="aUbicacion"  
                className={(buttonActive === 4)?'btn btn-primary':'btn btn-default'} 
                >Ubicaci&oacute;n
            </a>)}
            {estadoDxNum >= 5 && (
            <a href={`/dx/victimizacion/${iddx}/${idrecepcion}`} 
                id="aVictimizacion"  
                className={(buttonActive === 5)?'btn btn-primary':'btn btn-default'} 
                >Victimizaci&oacute;n
            </a>)}
            {estadoDxNum >= 6 && (
            <a href={`/dx/derechos/${iddx}/${idrecepcion}`} 
                id="aDerechos"  
                className={(buttonActive === 6)?'btn btn-primary':'btn btn-default'} 
                disabled={estadoDxNum <= 5}
                >Derechos
            </a>)}
            {estadoDxNum >= 7 && (
            <a href={`/dx/resultado/${iddx}/${idrecepcion}`} 
                id="aResultado"  
                className={(buttonActive === 7)?'btn btn-primary':'btn btn-default'} 
                disabled={estadoDxNum <= 6}
                >Resultado
            </a>)}
        </div>
    );
};

export default MenuEnlacesDX;